(() => {
  'use strict';
  if (window.__ibQuickAddFinalV61Loaded) return;
  window.__ibQuickAddFinalV61Loaded = true;

  let frame = 0;
  let observer;

  const getModalRoot = () => document.getElementById('quick-add-modal-content');

  const getSelectedVariantId = (root) => {
    const picker = root?.querySelector('variant-picker, swatches-variant-picker-component');
    if (!picker) return '';

    const selected = Array.from(
      picker.querySelectorAll(
        'fieldset input:checked[data-variant-id], select option:checked[data-variant-id], select option[selected][data-variant-id]'
      )
    );

    for (let index = selected.length - 1; index >= 0; index -= 1) {
      const variantId = selected[index]?.dataset?.variantId;
      if (variantId) return String(variantId);
    }

    try {
      const json = picker.querySelector('script[type="application/json"]')?.textContent;
      const resource = json ? JSON.parse(json) : null;
      if (resource?.id) return String(resource.id);
    } catch {
      // The picker can be between two server-rendered states while changing variant.
    }

    return '';
  };

  const syncSelectedVariantId = () => {
    const root = getModalRoot();
    const formComponent = root?.querySelector('product-form-component');
    const variantInput = formComponent?.querySelector('input[name="id"][ref="variantId"], input[name="id"]');
    const selectedVariantId = getSelectedVariantId(root);

    if (!variantInput || !selectedVariantId) return;

    if (variantInput.value !== selectedVariantId) {
      variantInput.value = selectedVariantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: false }));
    }

    variantInput.removeAttribute('disabled');
    formComponent.dataset.ibQuickAddVariantId = selectedVariantId;
  };

  const placeSkuInDetails = () => {
    const root = getModalRoot();
    const details = root?.querySelector('.product-details');
    const content =
      details?.querySelector(':scope > .group-block > .group-block-content') ||
      details?.querySelector('.group-block-content') ||
      details;
    const sku = root?.querySelector('[data-ib-quick-add-sku]');

    if (!content || !sku) return;

    const title = content.querySelector('.view-product-title');
    const correctlyPlaced =
      sku.parentElement === content &&
      (title ? sku.previousElementSibling === title : sku === content.firstElementChild);

    if (correctlyPlaced) return;

    if (title) title.insertAdjacentElement('afterend', sku);
    else content.prepend(sku);
  };

  const runScheduledWork = () => {
    frame = 0;
    placeSkuInDetails();
    syncSelectedVariantId();
  };

  const scheduleWork = () => {
    if (!frame) frame = requestAnimationFrame(runScheduledWork);
  };

  const start = () => {
    const dialog = document.getElementById('quick-add-dialog');
    if (!dialog) return;

    observer?.disconnect();
    observer = new MutationObserver(scheduleWork);
    observer.observe(dialog, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    dialog.addEventListener('change', scheduleWork);
    dialog.addEventListener('input', scheduleWork);

    // Synchronize before the click's default action generates the form submit.
    dialog.addEventListener(
      'click',
      (event) => {
        if (event.target instanceof Element && event.target.closest('[ref="addToCartButton"], button[type="submit"]')) {
          syncSelectedVariantId();
        }
      },
      true
    );

    // Covers keyboard submission as well as pointer activation.
    dialog.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Enter') syncSelectedVariantId();
      },
      true
    );

    scheduleWork();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
